import Breadcrumbs from "@/components/Breadcrumbs";
import { projectEditUrlBuilder, projectUrlBuilder, siteUrlBuilder } from "@/lib/url-builder";
import { Project, ProjectService } from "@/services/ProjectService";
import {  useParams, useNavigate } from "react-router";
import ProjectForm from "@/components/project/project-form";
import { useState } from "react";

const ProjectCreatePage: React.FC = () => {
  const params = useParams();
  const navigate = useNavigate()
  const [project, setProject] = useState(new Project("", "", params.siteId!, params.tenantId!, "68b4704749b0f309d2a4af2a", "68b4770949b0f309d2a4af39", 0, 0, null, null))

  return (
    <div className="container mx-auto p-4">
      <Breadcrumbs links={[
        {
          to: siteUrlBuilder(params.tenantId!, params.siteId!),
          label: "Map",
          isLink: true
        },
        {
          to: projectUrlBuilder(params.tenantId!, params.siteId!),
          label: "Projects",
          isLink: true
        }
      ]} />
    <ProjectForm 
      project={project}
      onSave={async project => {
        project.tenantId = params.tenantId!;
        const createProject = await ProjectService.create(project)
        setProject(createProject)
        navigate(projectEditUrlBuilder(params.tenantId!, params.siteId!, createProject.id))
      }}
       />
    </div>)
}

export default ProjectCreatePage;
